// @flow

import React, { type Node } from 'react';

type SelectProps = {
  children: Node,
  readOnly?: boolean,
};

export function Select({ children, readOnly, ...rest }: SelectProps): Node {
  return (
    <>
      <select
        {...rest}
        className="field__input field__input--select"
        readOnly={readOnly}
        style={{ opacity: readOnly ? '.4' : '1' }}
      >
        {children}
      </select>
      <div className="field__caret">
        <svg className="icon-svg icon-svg--color-adaptive-lighter icon-svg--size-10 field__caret-svg" role="presentation" aria-hidden="true" focusable="false">
          <path d="M0 3h10L5 8" fillRule="nonzero"></path>
        </svg>
      </div>
    </>
  );
}

type SelectOptionProps = {
  children: Node,
};

export function SelectOption({ children, ...rest }: SelectOptionProps): Node {
  return (
    <option {...rest}>
      {children}
    </option>
  );
}
